﻿import { IMilestoneBase, IMilestoneTemplate } from "@/interfaces";
import { isValidProductCategory } from ".";
import { IGetMilestones } from "../";

type IGetTopLevelMilestones = Omit<IGetMilestones, "parentId">;

export const getTopLevelMilestones = ({
  isTemplate,
  milestoneTemplates,
  project,
  flattenedMilestones,
}: IGetTopLevelMilestones): IMilestoneBase[] => {
  const templateHasMilestones = isTemplate && milestoneTemplates?.length;

  if (templateHasMilestones) {
    return milestoneTemplates.filter(
      (milestone: IMilestoneTemplate) =>
        isValidProductCategory(milestone, project) && milestone.isActive
    );
  }

  if (!isTemplate) {
    return flattenedMilestones.filter(({ canBeAdded }) => canBeAdded);
  }

  return [];
};
